import { render, staticRenderFns } from "./EditCampaignDialog.vue?vue&type=template&id=2383e6f9&scoped=true&"
import script from "./EditCampaignDialog.vue?vue&type=script&lang=js&"
export * from "./EditCampaignDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditCampaignDialog.vue?vue&type=style&index=0&id=2383e6f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383e6f9",
  null
  
)

/* custom blocks */
import block0 from "./EditCampaignDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports